import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import VueAxios from 'vue-axios';
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import * as firebase from 'firebase/app';
import 'firebase/functions';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueTheMask from 'vue-the-mask';
import 'bootstrap';
import VueCurrencyFilter from 'vue-currency-filter'
import { FIREBASE_CONFIG } from './environments/firebase-config';


if (firebase.apps.length === 0) {
  firebase.initializeApp(FIREBASE_CONFIG);
}
// firebase.functions().useFunctionsEmulator('http://localhost:50001');
// firebase.analytics();
// firebase.functions().useFunctionsEmulator('http://localhost:50001');
// const db = firebase.firestore();
// db.settings({host: 'localhost:8100', ssl: false});
// db.collection('users').add({createdAt: new Date()});



firebase.getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = firebase.auth().onAuthStateChanged(user => {
      unsubscribe();
      resolve(user);
    }, reject);
  })
};


Vue.config.productionTip = false
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueTheMask);
Vue.use(VueCurrencyFilter,
  {
    symbol: 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  });

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
